<template>
  <v-flex xs6 class="my-raports-card-wrapper">
    <v-card
      @click="viewMyRaportsByStatus()"
      class="my-raports-card"
      :style="{
        'borderBottom': '2px solid' + status_info.color
      }"
    >
      <div class="my-raports-categ-title">{{getStatusInfo(status_info)}}</div>
      <div
        class="my-raports-categ-number"
        :style="{
        'color': status_info.color
      }"
      >{{length_my_raports_by_status}}</div>
      <div class="my-raports-categ-number-bg">{{length_my_raports_by_status}}</div>
    </v-card>
  </v-flex>
</template>

<script>
import reports from "@/config/api/api_events/reports";
import native_capacitor from "@/config/js_helper/native_capacitor";

export default {
  name: "MyReportCard",
  props: {
    status_info: {
      type: [Array, Object],
      required: true
    }
  },
  data() {
    return {
      reports_by_status: [],
      length_my_raports_by_status: 0
    };
  },
  mounted() {
    this.getMyReportByStatus(this.status_info.id);
  },
  methods: {
    getStatusInfo(status_info) {
      return this.$store.state.type_language == 1
        ? status_info.code_al
        : status_info.code_en;
    },
    getMyReportByStatus(status) {
      reports
        .getUserReports({
          userID: localStorage.getItem("user_id")
        })
        .then(response => {
          var report_response = response.data.report;
          if (status == -1) {
            this.reports_by_status = report_response;
            this.length_my_raports_by_status = report_response.length;
          } else {
            this.reports_by_status = report_response.filter(
              el => el.status == status
            );
            this.length_my_raports_by_status = this.reports_by_status.length;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    viewMyRaportsByStatus() {
      this.$router.push({
        name: "ViewMyReport",
        path: "/report/viewmyreport",
        params: {
          reports_coming_from_status: this.reports_by_status,
          color_by_status: this.status_info.color
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped >
.my-raports-card-wrapper {
  padding: 12px !important;
  .my-raports-card {
    border-left: 2px solid;
    background-color: white;
    border: 0;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05) !important;
    border-radius: 10px;
    height: 80px;
    display: flex;
    flex-direction: column;
    padding: 15px;
    position: relative !important;
    justify-content: center;
    .my-raports-categ-title {
      text-transform: uppercase;
      z-index: 11;
      font-size: 12px;
    }
    .my-raports-categ-number {
      color: #e60000;
      font-weight: 700;
    }
    .my-raports-categ-number-bg {
      position: absolute;
      right: 15px;
      font-size: 65px;
      font-weight: 900;
      color: #f9f9f9;
      z-index: 10;
    }
  }
}
.my-raports-new {
  border: 2px #686868 dashed;
  justify-content: center;
  align-items: center;
  position: relative;
  .raports-title-new {
    font-size: 40px;
    color: #f9f9f9;
    font-weight: 900;
    letter-spacing: 15px;
    text-transform: uppercase;
  }
  .raport-plus {
    font-size: 60px;
    position: absolute;
    color: #686868;
  }
}
</style>